<template>
  <div v-if="show">
    <div class="overlay" @click="close"></div>

    <div class="modal" :class="`${className}`">
      <div class="modal-content">
        <slot></slot>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "modal",
  props: {
    show: {
      required: true,
      type: Boolean
    },
    oustsideClick: {
      required: false,
      default: true,
      type: Boolean
    },
    className: {
      required: false,
      default: "",
      type: String
    }
  },
  methods: {
    close() {
      this.$emit("close");
    }
  }
};
</script>

<style lang="scss">
.overlay {
  position: fixed;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  z-index: 4;
  background: rgba(31, 50, 22, 0.9);
  animation: slowOpen 0.2s ease-in;
  overflow: hidden;
}

@keyframes slowOpen {
  0% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
}

.modal {
  position: absolute;
  overflow: hidden;
  display: flex;
  justify-content: center;
  align-items: center;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;

  &-content {
    position: absolute;
    background-color: #fff;
    width: 100%;
    max-width: 350px;
    height: auto;
    z-index: 4;
  }
}

.delete-modal {
  .modal-content {
    max-width: 460px !important;
    position: absolute;
    background-color: transparent !important;
    width: 100%;
  }

  .form_w460 .form__address-close {
    right: 0 !important;
    top: 0 !important;
  }

  .btn {
    font-size: 14px;
  }
}

.address-modal {
  .modal-content {
    position: relative;
    max-width: 460px;
    background-color: transparent;
  }
}

.office-modal {
  .modal-content {
    top: 170px;
    max-width: 400px;
    background-color: transparent;
    display: flex;
    justify-content: center;
  }
}

.details-modal,
.edit-comment-and-files-modal,
.edit-order-modal {
  .modal-content {
    background-color: transparent !important;
  }
}

.edit-comment-and-files-modal {
  overflow: unset !important;

  .modal-content {
    max-height: 85vh !important;
    overflow-y: scroll !important;
  }
}

.edit-order-modal {
  overflow: unset !important;
}
// .details-modal {
//   .modal-content {
//     max-width: 380px;
//     position: absolute;
//     background-color: transparent;
//   }
// }

@media (max-width: 768px) {
  .address-modal {
    // height: 80vh;

    // .modal-content {
    //   position: absolute;
    //   top: 0;
    //   bottom: 0;
    //   margin: auto;

    //   .form {
    //     height: 80vh !important;
    //   }
    // }

    .modal-content {
      max-width: calc(100% - 40px);
      margin: 0 auto;
    }
  }

  body .delete-modal {
    .modal-content {
      max-width: 80% !important;
      // min-width: 230px;
    }

    .orders-page .form_w460 {
      max-width: 80% !important;
    }
  }
}
</style>
